import store from '../transfer/stores/configureStore'
import { triggerExternalHook } from '../transfer/actions/Actions'
import _ from 'lodash'
import { ENV_TYPE } from '../../../lib/constants'

const ONE_TOUCH_AUTH_STATE = 'REMEMBERED'

export function isOneTouchUser() {
  return (
    _.get(store.getState(), 'server.userAuthState') === ONE_TOUCH_AUTH_STATE
  )
}

export function requestLoginAction() {
  const { server } = store.getState()

  // `donate` will redirect the user to UL
  if (server.env === ENV_TYPE.DONATE) {
    return triggerExternalHook('requestUnifiedLogin')
  }
}
